import { render } from "./HistorialPagosColegiaturaPage.vue?vue&type=template&id=79bea24e"
import script from "./HistorialPagosColegiaturaPage.vue?vue&type=script&lang=js"
export * from "./HistorialPagosColegiaturaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__